import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ImagePreviewOpenOptions {
  fileName?: string;
  fileId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImagePreviewService {

  previewUrl = '';
  fileName = '';
  fileId = '';
  visible = false;
  openEvent = new Subject<string>();

  open(imageUrl: string, options?: ImagePreviewOpenOptions) {
    if (!imageUrl) {
      return;
    }
    this.previewUrl = imageUrl;
    this.fileName = options?.fileName?.trim() || '';
    this.fileId = options?.fileId || '';
    this.visible = true;
    this.openEvent.next(imageUrl);
  }

  close() {
    this.visible = false;
    this.previewUrl = '';
    this.fileName = '';
    this.fileId = '';
  }
}
